Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Bezier = void 0;
var _worklet_10454951261768_init_data = {
    code: "function Bezier(mX1,mY1,mX2,mY2){const NEWTON_ITERATIONS=4;const NEWTON_MIN_SLOPE=0.001;const SUBDIVISION_PRECISION=0.0000001;const SUBDIVISION_MAX_ITERATIONS=10;const kSplineTableSize=11;const kSampleStepSize=1.0/(kSplineTableSize-1.0);function A(aA1,aA2){'worklet';return 1.0-3.0*aA2+3.0*aA1;}function B(aA1,aA2){'worklet';return 3.0*aA2-6.0*aA1;}function C(aA1){'worklet';return 3.0*aA1;}function calcBezier(aT,aA1,aA2){'worklet';return((A(aA1,aA2)*aT+B(aA1,aA2))*aT+C(aA1))*aT;}function getSlope(aT,aA1,aA2){'worklet';return 3.0*A(aA1,aA2)*aT*aT+2.0*B(aA1,aA2)*aT+C(aA1);}function binarySubdivide(aX,aA,aB,mX1,mX2){'worklet';let currentX;let currentT;let i=0;do{currentT=aA+(aB-aA)/2.0;currentX=calcBezier(currentT,mX1,mX2)-aX;if(currentX>0.0){aB=currentT;}else{aA=currentT;}}while(Math.abs(currentX)>SUBDIVISION_PRECISION&&++i<SUBDIVISION_MAX_ITERATIONS);return currentT;}function newtonRaphsonIterate(aX,aGuessT,mX1,mX2){'worklet';for(let i=0;i<NEWTON_ITERATIONS;++i){const currentSlope=getSlope(aGuessT,mX1,mX2);if(currentSlope===0.0){return aGuessT;}const currentX=calcBezier(aGuessT,mX1,mX2)-aX;aGuessT-=currentX/currentSlope;}return aGuessT;}function LinearEasing(x){'worklet';return x;}if(!(mX1>=0&&mX1<=1&&mX2>=0&&mX2<=1)){throw new Error('[Reanimated] Bezier x values must be in [0, 1] range.');}if(mX1===mY1&&mX2===mY2){return LinearEasing;}const sampleValues=new Array(kSplineTableSize);for(let i=0;i<kSplineTableSize;++i){sampleValues[i]=calcBezier(i*kSampleStepSize,mX1,mX2);}function getTForX(aX){'worklet';let intervalStart=0.0;let currentSample=1;const lastSample=kSplineTableSize-1;for(;currentSample!==lastSample&&sampleValues[currentSample]<=aX;++currentSample){intervalStart+=kSampleStepSize;}--currentSample;const dist=(aX-sampleValues[currentSample])/(sampleValues[currentSample+1]-sampleValues[currentSample]);const guessForT=intervalStart+dist*kSampleStepSize;const initialSlope=getSlope(guessForT,mX1,mX2);if(initialSlope>=NEWTON_MIN_SLOPE){return newtonRaphsonIterate(aX,guessForT,mX1,mX2);}else if(initialSlope===0.0){return guessForT;}else{return binarySubdivide(aX,intervalStart,intervalStart+kSampleStepSize,mX1,mX2);}}return function BezierEasing(x){'worklet';if(mX1===mY1&&mX2===mY2){return x;}if(x===0){return 0;}if(x===1){return 1;}return calcBezier(getTForX(x),mY1,mY2);};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["Bezier","mX1","mY1","mX2","mY2","NEWTON_ITERATIONS","NEWTON_MIN_SLOPE","SUBDIVISION_PRECISION","SUBDIVISION_MAX_ITERATIONS","kSplineTableSize","kSampleStepSize","A","aA1","aA2","B","C","calcBezier","aT","getSlope","binarySubdivide","aX","aA","aB","currentX","currentT","i","Math","abs","newtonRaphsonIterate","aGuessT","currentSlope","LinearEasing","x","Error","sampleValues","Array","getTForX","intervalStart","currentSample","lastSample","dist","guessForT","initialSlope","BezierEasing"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AAQO,SAAAA,MAASA,CACdC,GAAA,CAAWC,GACX,CAAWC,GACX,CAAWC,GACX,CACD,CAGC,KAAM,CAAAC,iBAAiB,CAAG,CAAC,CAC3B,KAAM,CAAAC,gBAAgB,CAAG,KAAK,CAC9B,KAAM,CAAAC,qBAAqB,CAAG,SAAS,CACvC,KAAM,CAAAC,0BAA0B,CAAG,EAAE,CAErC,KAAM,CAAAC,gBAAgB,CAAG,EAAE,CAC3B,KAAM,CAAAC,eAAe,CAAG,GAAG,EAAID,gBAAgB,CAAG,GAAG,CAAC,CAEtD,QAAS,CAAAE,CAACA,CAACC,GAAW,CAAEC,GAAW,CAAU,CAC3C,SAAS,CACT,MAAO,IAAG,CAAG,GAAG,CAAGA,GAAG,CAAG,GAAG,CAAGD,GAAG,CACpC,CACA,QAAS,CAAAE,CAACA,CAACF,GAAW,CAAEC,GAAW,CAAU,CAC3C,SAAS,CACT,MAAO,IAAG,CAAGA,GAAG,CAAG,GAAG,CAAGD,GAAG,CAC9B,CACA,QAAS,CAAAG,CAACA,CAACH,GAAW,CAAE,CACtB,SAAS,CACT,MAAO,IAAG,CAAGA,GAAG,CAClB,CAGA,QAAS,CAAAI,UAAUA,CAACC,EAAU,CAAEL,GAAW,CAAEC,GAAW,CAAU,CAChE,SAAS,CACT,MAAO,CAAC,CAACF,CAAC,CAACC,GAAG,CAAEC,GAAG,CAAC,CAAGI,EAAE,CAAGH,CAAC,CAACF,GAAG,CAAEC,GAAG,CAAC,EAAII,EAAE,CAAGF,CAAC,CAACH,GAAG,CAAC,EAAIK,EAAE,CAC9D,CAGA,QAAS,CAAAC,QAAQA,CAACD,EAAU,CAAEL,GAAW,CAAEC,GAAW,CAAU,CAC9D,SAAS,CACT,MAAO,IAAG,CAAGF,CAAC,CAACC,GAAG,CAAEC,GAAG,CAAC,CAAGI,EAAE,CAAGA,EAAE,CAAG,GAAG,CAAGH,CAAC,CAACF,GAAG,CAAEC,GAAG,CAAC,CAAGI,EAAE,CAAGF,CAAC,CAACH,GAAG,CAAC,CACtE,CAEA,QAAS,CAAAO,eAAeA,CACtBC,EAAU,CACVC,EAAU,CACVC,EAAU,CACVrB,GAAW,CACXE,GAAW,CACH,CACR,SAAS,CACT,GAAI,CAAAoB,QAAQ,CACZ,GAAI,CAAAC,QAAQ,CACZ,GAAI,CAAAC,CAAC,CAAG,CAAC,CACT,EAAG,CACDD,QAAQ,CAAGH,EAAE,CAAG,CAACC,EAAE,CAAGD,EAAE,EAAI,GAAG,CAC/BE,QAAQ,CAAGP,UAAU,CAACQ,QAAQ,CAAEvB,GAAG,CAAEE,GAAG,CAAC,CAAGiB,EAAE,CAC9C,GAAIG,QAAQ,CAAG,GAAG,CAAE,CAClBD,EAAE,CAAGE,QAAQ,CACf,CAAC,IAAM,CACLH,EAAE,CAAGG,QAAQ,CACf,CACF,CAAC,MACCE,IAAI,CAACC,GAAG,CAACJ,QAAQ,CAAC,CAAGhB,qBAAqB,EAC1C,EAAEkB,CAAC,CAAGjB,0BAA0B,EAElC,MAAO,CAAAgB,QAAQ,CACjB,CAEA,QAAS,CAAAI,oBAAoBA,CAC3BR,EAAU,CACVS,OAAe,CACf5B,GAAW,CACXE,GAAW,CACH,CACR,SAAS,CACT,IAAK,GAAI,CAAAsB,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGpB,iBAAiB,CAAE,EAAEoB,CAAC,CAAE,CAC1C,KAAM,CAAAK,YAAY,CAAGZ,QAAQ,CAACW,OAAO,CAAE5B,GAAG,CAAEE,GAAG,CAAC,CAChD,GAAI2B,YAAY,GAAK,GAAG,CAAE,CACxB,MAAO,CAAAD,OAAO,CAChB,CACA,KAAM,CAAAN,QAAQ,CAAGP,UAAU,CAACa,OAAO,CAAE5B,GAAG,CAAEE,GAAG,CAAC,CAAGiB,EAAE,CACnDS,OAAO,EAAIN,QAAQ,CAAGO,YAAY,CACpC,CACA,MAAO,CAAAD,OAAO,CAChB,CAEA,QAAS,CAAAE,YAAYA,CAACC,CAAS,CAAU,CACvC,SAAS,CACT,MAAO,CAAAA,CAAC,CACV,CAEA,GAAI,EAAE/B,GAAG,EAAI,CAAC,EAAIA,GAAG,EAAI,CAAC,EAAIE,GAAG,EAAI,CAAC,EAAIA,GAAG,EAAI,CAAC,CAAC,CAAE,CACnD,KAAM,IAAI,CAAA8B,KAAK,CAAC,uDAAuD,CAAC,CAC1E,CAEA,GAAIhC,GAAG,GAAKC,GAAG,EAAIC,GAAG,GAAKC,GAAG,CAAE,CAC9B,MAAO,CAAA2B,YAAY,CACrB,CAUA,KAAM,CAAAG,YAAY,CAAG,GAAI,CAAAC,KAAK,CAAC1B,gBAAgB,CAAC,CAEhD,IAAK,GAAI,CAAAgB,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGhB,gBAAgB,CAAE,EAAEgB,CAAC,CAAE,CACzCS,YAAY,CAACT,CAAC,CAAC,CAAGT,UAAU,CAACS,CAAC,CAAGf,eAAe,CAAET,GAAG,CAAEE,GAAG,CAAC,CAC7D,CAEA,QAAS,CAAAiC,QAAQA,CAAChB,EAAU,CAAU,CACpC,SAAS,CACT,GAAI,CAAAiB,aAAa,CAAG,GAAG,CACvB,GAAI,CAAAC,aAAa,CAAG,CAAC,CACrB,KAAM,CAAAC,UAAU,CAAG9B,gBAAgB,CAAG,CAAC,CAEvC,KAEE6B,aAAa,GAAKC,UAAU,EAAIL,YAAY,CAACI,aAAa,CAAC,EAAIlB,EAAE,CACjE,EAAEkB,aAAa,CACf,CACAD,aAAa,EAAI3B,eAAe,CAClC,CACA,EAAE4B,aAAa,CAGf,KAAM,CAAAE,IAAI,CACR,CAACpB,EAAE,CAAGc,YAAY,CAACI,aAAa,CAAC,GAChCJ,YAAY,CAACI,aAAa,CAAG,CAAC,CAAC,CAAGJ,YAAY,CAACI,aAAa,CAAC,CAAC,CACjE,KAAM,CAAAG,SAAS,CAAGJ,aAAa,CAAGG,IAAI,CAAG9B,eAAe,CAExD,KAAM,CAAAgC,YAAY,CAAGxB,QAAQ,CAACuB,SAAS,CAAExC,GAAG,CAAEE,GAAG,CAAC,CAClD,GAAIuC,YAAY,EAAIpC,gBAAgB,CAAE,CACpC,MAAO,CAAAsB,oBAAoB,CAACR,EAAE,CAAEqB,SAAS,CAAExC,GAAG,CAAEE,GAAG,CAAC,CACtD,CAAC,IAAM,IAAIuC,YAAY,GAAK,GAAG,CAAE,CAC/B,MAAO,CAAAD,SAAS,CAClB,CAAC,IAAM,CACL,MAAO,CAAAtB,eAAe,CACpBC,EAAE,CACFiB,aAAa,CACbA,aAAa,CAAG3B,eAAe,CAC/BT,GAAG,CACHE,GACF,CAAC,CACH,CACF,CAEA,MAAO,SAAS,CAAAwC,YAAYA,CAACX,CAAC,CAAE,CAC9B,SAAS,CACT,GAAI/B,GAAG,GAAKC,GAAG,EAAIC,GAAG,GAAKC,GAAG,CAAE,CAC9B,MAAO,CAAA4B,CAAC,CACV,CAEA,GAAIA,CAAC,GAAK,CAAC,CAAE,CACX,MAAO,EAAC,CACV,CACA,GAAIA,CAAC,GAAK,CAAC,CAAE,CACX,MAAO,EAAC,CACV,CACA,MAAO,CAAAhB,UAAU,CAACoB,QAAQ,CAACJ,CAAC,CAAC,CAAE9B,GAAG,CAAEE,GAAG,CAAC,CAC1C,CAAC,CACH"}',
    version: "3.5.4"
};
var _worklet_7696928702327_init_data = {
    code: "function A(aA1,aA2){return 1.0-3.0*aA2+3.0*aA1;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["A","aA1","aA2"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AAwBE,SAAAA,CAAUA,CAACC,GAAA,CAAWC,GAAE,CAAY,CAElC,MAAO,IAAG,CAAG,GAAG,CAAGA,GAAG,CAAG,GAAG,CAAGD,GAAG,CACpC"}',
    version: "3.5.4"
};
var _worklet_3169786778773_init_data = {
    code: "function B(aA1,aA2){return 3.0*aA2-6.0*aA1;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["B","aA1","aA2"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AA4BE,SAAAA,CAAUA,CAACC,GAAA,CAAWC,GAAE,CAAY,CAElC,MAAO,IAAG,CAAGA,GAAG,CAAG,GAAG,CAAGD,GAAG,CAC9B"}',
    version: "3.5.4"
};
var _worklet_6399610653367_init_data = {
    code: "function C(aA1){return 3.0*aA1;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["C","aA1"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AAgCE,SAAAA,CAAUA,CAACC,GAAA,CAAW,CAEpB,MAAO,IAAG,CAAGA,GAAG,CAClB"}',
    version: "3.5.4"
};
var _worklet_11609037530968_init_data = {
    code: "function calcBezier(aT,aA1,aA2){const{A,B,C}=this.__closure;return((A(aA1,aA2)*aT+B(aA1,aA2))*aT+C(aA1))*aT;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["calcBezier","aT","aA1","aA2","A","B","C","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AAqCE,SAAAA,WAAAC,EAAA,CAAAC,GAAA,CAAAC,GAAA,QAAAC,CAAA,CAAAC,CAAA,CAAAC,CAAA,OAAAC,SAAA,SAAAH,CAAA,CAAAF,GAAA,CAAAC,GAAA,EAAAF,EAAA,CAAAI,CAAA,CAAAH,GAAA,CAAAC,GAAA,GAAAF,EAAA,CAAAK,CAAA,CAAAJ,GAAA,GAAAD,EAAA,CACA"}',
    version: "3.5.4"
};
var _worklet_15662297546628_init_data = {
    code: "function getSlope(aT,aA1,aA2){const{A,B,C}=this.__closure;return 3.0*A(aA1,aA2)*aT*aT+2.0*B(aA1,aA2)*aT+C(aA1);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["getSlope","aT","aA1","aA2","A","B","C","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AA2CE,SAAAA,SAAAC,EAAA,CAAAC,GAAA,CAAAC,GAAA,QAAAC,CAAA,CAAAC,CAAA,CAAAC,CAAA,OAAAC,SAAA,YAAAH,CAAA,CAAAF,GAAA,CAAAC,GAAA,EAAAF,EAAA,CAAAA,EAAA,KAAAI,CAAA,CAAAH,GAAA,CAAAC,GAAA,EAAAF,EAAA,CAAAK,CAAA,CAAAJ,GAAA,EACA"}',
    version: "3.5.4"
};
var _worklet_16662566953555_init_data = {
    code: "function binarySubdivide(aX,aA,aB,mX1,mX2){const{SUBDIVISION_PRECISION,SUBDIVISION_MAX_ITERATIONS,calcBezier}=this.__closure;let currentX;let currentT;let i=0;do{currentT=aA+(aB-aA)/2.0;currentX=calcBezier(currentT,mX1,mX2)-aX;if(currentX>0.0){aB=currentT;}else{aA=currentT;}}while(Math.abs(currentX)>SUBDIVISION_PRECISION&&++i<SUBDIVISION_MAX_ITERATIONS);return currentT;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["binarySubdivide","aX","aA","aB","mX1","mX2","SUBDIVISION_PRECISION","SUBDIVISION_MAX_ITERATIONS","calcBezier","__closure","currentX","currentT","i","Math","abs"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AAiDE,SAAAA,eAASA,CACPC,EAAA,CAAUC,EACV,CAAUC,EACV,CAAUC,GACV,CAAWC,GACX,CACD,OAAAC,qBAAA,CAAAC,0BAAA,CAAAC,UAAA,OAAAC,SAAA,CAEC,GAAI,CAAAC,QAAQ,CACZ,GAAI,CAAAC,QAAQ,CACZ,GAAI,CAAAC,CAAC,CAAG,CAAC,CACT,EAAG,CACDD,QAAQ,CAAGT,EAAE,CAAG,CAACC,EAAE,CAAGD,EAAE,EAAI,GAAG,CAC/BQ,QAAQ,CAAGF,UAAU,CAACG,QAAQ,CAAEP,GAAG,CAAEC,GAAG,CAAC,CAAGJ,EAAE,CAC9C,GAAIS,QAAQ,CAAG,GAAG,CAAE,CAClBP,EAAE,CAAGQ,QAAQ,CACf,CAAC,IAAM,CACLT,EAAE,CAAGS,QAAQ,CACf,CACF,CAAC,MACCE,IAAI,CAACC,GAAG,CAACJ,QAAQ,CAAC,CAAGJ,qBAAqB,EAC1C,EAAEM,CAAC,CAAGL,0BAA0B,EAElC,MAAO,CAAAI,QAAQ,CACjB"}',
    version: "3.5.4"
};
var _worklet_4538502018300_init_data = {
    code: "function newtonRaphsonIterate(aX,aGuessT,mX1,mX2){const{NEWTON_ITERATIONS,getSlope,calcBezier}=this.__closure;for(let i=0;i<NEWTON_ITERATIONS;++i){const currentSlope=getSlope(aGuessT,mX1,mX2);if(currentSlope===0.0){return aGuessT;}const currentX=calcBezier(aGuessT,mX1,mX2)-aX;aGuessT-=currentX/currentSlope;}return aGuessT;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["newtonRaphsonIterate","aX","aGuessT","mX1","mX2","NEWTON_ITERATIONS","getSlope","calcBezier","__closure","i","currentSlope","currentX"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AA2EE,SAAAA,oBAASA,CACPC,EAAA,CAAUC,OACV,CAAeC,GACf,CAAWC,GACX,CACD,OAAAC,iBAAA,CAAAC,QAAA,CAAAC,UAAA,OAAAC,SAAA,CAEC,IAAK,GAAI,CAAAC,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGJ,iBAAiB,CAAE,EAAEI,CAAC,CAAE,CAC1C,KAAM,CAAAC,YAAY,CAAGJ,QAAQ,CAACJ,OAAO,CAAEC,GAAG,CAAEC,GAAG,CAAC,CAChD,GAAIM,YAAY,GAAK,GAAG,CAAE,CACxB,MAAO,CAAAR,OAAO,CAChB,CACA,KAAM,CAAAS,QAAQ,CAAGJ,UAAU,CAACL,OAAO,CAAEC,GAAG,CAAEC,GAAG,CAAC,CAAGH,EAAE,CACnDC,OAAO,EAAIS,QAAQ,CAAGD,YAAY,CACpC,CACA,MAAO,CAAAR,OAAO,CAChB"}',
    version: "3.5.4"
};
var _worklet_3962143445177_init_data = {
    code: "function LinearEasing(x){return x;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["LinearEasing","x"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AA6FE,SAAAA,YAASA,CAAaC,CAAC,CAAS,CAE9B,MAAO,CAAAA,CAAC,CACV"}',
    version: "3.5.4"
};
var _worklet_1358253373504_init_data = {
    code: "function getTForX(aX){const{kSplineTableSize,sampleValues,kSampleStepSize,getSlope,mX1,mX2,NEWTON_MIN_SLOPE,newtonRaphsonIterate,binarySubdivide}=this.__closure;let intervalStart=0.0;let currentSample=1;const lastSample=kSplineTableSize-1;for(;currentSample!==lastSample&&sampleValues[currentSample]<=aX;++currentSample){intervalStart+=kSampleStepSize;}--currentSample;const dist=(aX-sampleValues[currentSample])/(sampleValues[currentSample+1]-sampleValues[currentSample]);const guessForT=intervalStart+dist*kSampleStepSize;const initialSlope=getSlope(guessForT,mX1,mX2);if(initialSlope>=NEWTON_MIN_SLOPE){return newtonRaphsonIterate(aX,guessForT,mX1,mX2);}else if(initialSlope===0.0){return guessForT;}else{return binarySubdivide(aX,intervalStart,intervalStart+kSampleStepSize,mX1,mX2);}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["getTForX","aX","kSplineTableSize","sampleValues","kSampleStepSize","getSlope","mX1","mX2","NEWTON_MIN_SLOPE","newtonRaphsonIterate","binarySubdivide","__closure","intervalStart","currentSample","lastSample","dist","guessForT","initialSlope"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AAwHE,SAAAA,QAASA,CAASC,EAAA,CAAW,OAAAC,gBAAA,CAAAC,YAAA,CAAAC,eAAA,CAAAC,QAAA,CAAAC,GAAA,CAAAC,GAAA,CAAAC,gBAAA,CAAAC,oBAAA,CAAAC,eAAA,OAAAC,SAAA,CAE3B,GAAI,CAAAC,aAAa,CAAG,GAAG,CACvB,GAAI,CAAAC,aAAa,CAAG,CAAC,CACrB,KAAM,CAAAC,UAAU,CAAGZ,gBAAgB,CAAG,CAAC,CAEvC,KAEEW,aAAa,GAAKC,UAAU,EAAIX,YAAY,CAACU,aAAa,CAAC,EAAIZ,EAAE,CACjE,EAAEY,aAAa,CACf,CACAD,aAAa,EAAIR,eAAe,CAClC,CACA,EAAES,aAAa,CAGf,KAAM,CAAAE,IAAI,CACR,CAACd,EAAE,CAAGE,YAAY,CAACU,aAAa,CAAC,GAChCV,YAAY,CAACU,aAAa,CAAG,CAAC,CAAC,CAAGV,YAAY,CAACU,aAAa,CAAC,CAAC,CACjE,KAAM,CAAAG,SAAS,CAAGJ,aAAa,CAAGG,IAAI,CAAGX,eAAe,CAExD,KAAM,CAAAa,YAAY,CAAGZ,QAAQ,CAACW,SAAS,CAAEV,GAAG,CAAEC,GAAG,CAAC,CAClD,GAAIU,YAAY,EAAIT,gBAAgB,CAAE,CACpC,MAAO,CAAAC,oBAAoB,CAACR,EAAE,CAAEe,SAAS,CAAEV,GAAG,CAAEC,GAAG,CAAC,CACtD,CAAC,IAAM,IAAIU,YAAY,GAAK,GAAG,CAAE,CAC/B,MAAO,CAAAD,SAAS,CAClB,CAAC,IAAM,CACL,MAAO,CAAAN,eAAe,CACpBT,EAAE,CACFW,aAAa,CACbA,aAAa,CAAGR,eAAe,CAC/BE,GAAG,CACHC,GACF,CAAC,CACH,CACF"}',
    version: "3.5.4"
};
var _worklet_5389798763829_init_data = {
    code: "function BezierEasing(x){const{mX1,mY1,mX2,mY2,calcBezier,getTForX}=this.__closure;if(mX1===mY1&&mX2===mY2){return x;}if(x===0){return 0;}if(x===1){return 1;}return calcBezier(getTForX(x),mY1,mY2);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts",
    sourceMap: '{"version":3,"names":["BezierEasing","x","mX1","mY1","mX2","mY2","calcBezier","getTForX","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Bezier.ts"],"mappings":"AA6JS,SAAAA,YAASA,CAAaC,CAAC,QAAAC,GAAA,CAAAC,GAAA,CAAAC,GAAA,CAAAC,GAAA,CAAAC,UAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5B,GAAIN,GAAG,GAAKC,GAAG,EAAIC,GAAG,GAAKC,GAAG,CAAE,CAC9B,MAAO,CAAAJ,CAAC,CACV,CAEA,GAAIA,CAAC,GAAK,CAAC,CAAE,CACX,MAAO,EAAC,CACV,CACA,GAAIA,CAAC,GAAK,CAAC,CAAE,CACX,MAAO,EAAC,CACV,CACA,MAAO,CAAAK,UAAU,CAACC,QAAQ,CAACN,CAAC,CAAC,CAAEE,GAAG,CAAEE,GAAG,CAAC,CAC1C"}',
    version: "3.5.4"
};
var Bezier = exports.Bezier = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var Bezier = function Bezier(mX1, mY1, mX2, mY2) {
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var A = function() {
            var _e = [
                new global.Error(),
                1,
                -27
            ];
            var A = function A(aA1, aA2) {
                return 1.0 - 3.0 * aA2 + 3.0 * aA1;
            };
            A.__closure = {};
            A.__initData = _worklet_7696928702327_init_data;
            A.__workletHash = 7696928702327;
            A.__stackDetails = _e;
            return A;
        }();
        var B = function() {
            var _e = [
                new global.Error(),
                1,
                -27
            ];
            var B = function B(aA1, aA2) {
                return 3.0 * aA2 - 6.0 * aA1;
            };
            B.__closure = {};
            B.__initData = _worklet_3169786778773_init_data;
            B.__workletHash = 3169786778773;
            B.__stackDetails = _e;
            return B;
        }();
        var C = function() {
            var _e = [
                new global.Error(),
                1,
                -27
            ];
            var C = function C(aA1) {
                return 3.0 * aA1;
            };
            C.__closure = {};
            C.__initData = _worklet_6399610653367_init_data;
            C.__workletHash = 6399610653367;
            C.__stackDetails = _e;
            return C;
        }();
        var calcBezier = function() {
            var _e = [
                new global.Error(),
                -4,
                -27
            ];
            var calcBezier = function calcBezier(aT, aA1, aA2) {
                return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
            };
            calcBezier.__closure = {
                A: A,
                B: B,
                C: C
            };
            calcBezier.__initData = _worklet_11609037530968_init_data;
            calcBezier.__workletHash = 11609037530968;
            calcBezier.__stackDetails = _e;
            return calcBezier;
        }();
        var getSlope = function() {
            var _e = [
                new global.Error(),
                -4,
                -27
            ];
            var getSlope = function getSlope(aT, aA1, aA2) {
                return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
            };
            getSlope.__closure = {
                A: A,
                B: B,
                C: C
            };
            getSlope.__initData = _worklet_15662297546628_init_data;
            getSlope.__workletHash = 15662297546628;
            getSlope.__stackDetails = _e;
            return getSlope;
        }();
        var binarySubdivide = function() {
            var _e = [
                new global.Error(),
                -4,
                -27
            ];
            var binarySubdivide = function binarySubdivide(aX, aA, aB, mX1, mX2) {
                var currentX;
                var currentT;
                var i = 0;
                do {
                    currentT = aA + (aB - aA) / 2.0;
                    currentX = calcBezier(currentT, mX1, mX2) - aX;
                    if (currentX > 0.0) {
                        aB = currentT;
                    } else {
                        aA = currentT;
                    }
                }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
                return currentT;
            };
            binarySubdivide.__closure = {
                SUBDIVISION_PRECISION: SUBDIVISION_PRECISION,
                SUBDIVISION_MAX_ITERATIONS: SUBDIVISION_MAX_ITERATIONS,
                calcBezier: calcBezier
            };
            binarySubdivide.__initData = _worklet_16662566953555_init_data;
            binarySubdivide.__workletHash = 16662566953555;
            binarySubdivide.__stackDetails = _e;
            return binarySubdivide;
        }();
        var newtonRaphsonIterate = function() {
            var _e = [
                new global.Error(),
                -4,
                -27
            ];
            var newtonRaphsonIterate = function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
                for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                    var currentSlope = getSlope(aGuessT, mX1, mX2);
                    if (currentSlope === 0.0) {
                        return aGuessT;
                    }
                    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                    aGuessT -= currentX / currentSlope;
                }
                return aGuessT;
            };
            newtonRaphsonIterate.__closure = {
                NEWTON_ITERATIONS: NEWTON_ITERATIONS,
                getSlope: getSlope,
                calcBezier: calcBezier
            };
            newtonRaphsonIterate.__initData = _worklet_4538502018300_init_data;
            newtonRaphsonIterate.__workletHash = 4538502018300;
            newtonRaphsonIterate.__stackDetails = _e;
            return newtonRaphsonIterate;
        }();
        var LinearEasing = function() {
            var _e = [
                new global.Error(),
                1,
                -27
            ];
            var LinearEasing = function LinearEasing(x) {
                return x;
            };
            LinearEasing.__closure = {};
            LinearEasing.__initData = _worklet_3962143445177_init_data;
            LinearEasing.__workletHash = 3962143445177;
            LinearEasing.__stackDetails = _e;
            return LinearEasing;
        }();
        if (!(mX1 >= 0 && mX1 <= 1 && mX2 >= 0 && mX2 <= 1)) {
            throw new Error("[Reanimated] Bezier x values must be in [0, 1] range.");
        }
        if (mX1 === mY1 && mX2 === mY2) {
            return LinearEasing;
        }
        var sampleValues = new Array(kSplineTableSize);
        for(var i = 0; i < kSplineTableSize; ++i){
            sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        }
        var getTForX = function() {
            var _e = [
                new global.Error(),
                -10,
                -27
            ];
            var getTForX = function getTForX(aX) {
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample){
                    intervalStart += kSampleStepSize;
                }
                --currentSample;
                var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) {
                    return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                } else if (initialSlope === 0.0) {
                    return guessForT;
                } else {
                    return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
                }
            };
            getTForX.__closure = {
                kSplineTableSize: kSplineTableSize,
                sampleValues: sampleValues,
                kSampleStepSize: kSampleStepSize,
                getSlope: getSlope,
                mX1: mX1,
                mX2: mX2,
                NEWTON_MIN_SLOPE: NEWTON_MIN_SLOPE,
                newtonRaphsonIterate: newtonRaphsonIterate,
                binarySubdivide: binarySubdivide
            };
            getTForX.__initData = _worklet_1358253373504_init_data;
            getTForX.__workletHash = 1358253373504;
            getTForX.__stackDetails = _e;
            return getTForX;
        }();
        return function() {
            var _e = [
                new global.Error(),
                -7,
                -27
            ];
            var BezierEasing = function BezierEasing(x) {
                if (mX1 === mY1 && mX2 === mY2) {
                    return x;
                }
                if (x === 0) {
                    return 0;
                }
                if (x === 1) {
                    return 1;
                }
                return calcBezier(getTForX(x), mY1, mY2);
            };
            BezierEasing.__closure = {
                mX1: mX1,
                mY1: mY1,
                mX2: mX2,
                mY2: mY2,
                calcBezier: calcBezier,
                getTForX: getTForX
            };
            BezierEasing.__initData = _worklet_5389798763829_init_data;
            BezierEasing.__workletHash = 5389798763829;
            BezierEasing.__stackDetails = _e;
            return BezierEasing;
        }();
    };
    Bezier.__closure = {};
    Bezier.__initData = _worklet_10454951261768_init_data;
    Bezier.__workletHash = 10454951261768;
    Bezier.__stackDetails = _e;
    return Bezier;
}();
